
import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import Icon from "@/components/ui/icon";
import { Extension } from "@/components/icons/ExtensionIcon";
import { useNavigate } from "react-router-dom";

const ExtensionMenu: React.FC = () => {
  const navigate = useNavigate();
  
  const handleGetChromeExtension = () => {
    // Open the Chrome Web Store link in a new tab
    window.open(
      "https://chromewebstore.google.com/detail/clustr-web-clipper/dpcmmgplcmlkbdejalgilbadledapadd?authuser=0&hl=en", 
      "_blank",
      "noopener,noreferrer"
    );
    toast.success("Opening Chrome Web Store");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="rounded-full p-1 hover:bg-clustr-overlay"
        >
          <Icon icon={Extension} size={20} strokeWidth={2} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem onClick={handleGetChromeExtension}>
          <Icon icon={Extension} size={16} className="mr-2" />
          <span>Get Chrome Clipper</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExtensionMenu;
